export const tazhiyeva = {
    id: "tazhiyeva",
    name: { ru: "Тажиева Айжан Альпикызы", kz: "Тажиева Айжан Альпиқызы" },
    position: { 
      ru: "Комплаенс-офицер ГКП на ПХВ «Спортивный медицинский центр» г. Астаны", 
      kz: "МКҚК «Астана қаласының спорттық медициналық орталығы» комплаенс-офицері" 
    },
    department: "management",
    image: "/team_photoes/Aizhan.svg",
    phone: "+7 778 778 88 93",
    email: "smo.compliance@mail.ru",
    education: {
      ru: `Высшее юридическое: Казахский гуманитарно-юридический университет (КАЗГЮУ)`,
      kz: `Жоғары заңгерлік: Қазақ гуманитарлық-заң университеті (ҚазГЗУ)`
    },
    specialization: {
      ru: `Профессиональный статус:
• Член Палаты юридических консультантов г. Алматы
• Профессиональный медиатор

Ключевые направления деятельности:
• Антикоррупционный комплаенс
• Системное развитие и внедрение системы внутреннего комплаенса
• Этическая среда и корпоративная этика
• Риск-менеджмент и оценка правовых рисков
• Медиация и досудебное урегулирование конфликтов`,
      kz: `Кәсіби мәртебесі:
• Алматы қаласының заң кеңесшілері палатасының мүшесі
• Кәсіби медиатор

Қызметтің негізгі бағыттары:
• Сыбайлас жемқорлыққа қарсы комплаенс
• Жүйелік даму және ішкі комплаенс жүйесін енгізу
• Этикалық орта және корпоративтік этика
• Тәуекелдерді басқару және құқықтық тәуекелдерді бағалау
• Медиация және сотқа дейінгі дауларды реттеу`
    },
    work: {
      ru: `Общий стаж в сфере государственной и правовой деятельности составляет 27 лет

• С 1999 года — Занимала ответственные должности в центральных государственных органах Республики Казахстан, включая Министерство транспорта и коммуникаций РК
• Многолетний опыт правового сопровождения деятельности госорганов, разработки и правовой экспертизы нормативных правовых актов (НПА), а также консультирования по вопросам применения законодательства РК
• С января 2025 года — Комплаенс-офицер Спортивного медицинского центра г. Астаны`,
      kz: `Мемлекеттік және құқықтық қызмет саласындағы жалпы еңбек өтілі 27 жыл

• 1999 жылдан бастап — Қазақстан Республикасының орталық мемлекеттік органдарында, соның ішінде ҚР Көлік және коммуникация министрлігінде жауапты лауазымдарда қызмет атқарған
• Мемлекеттік органдардың қызметін құқықтық қамтамасыз етуде, нормативтік құқықтық актілерді (НҚА) әзірлеу және құқықтық сараптамада, сондай-ақ ҚР заңнамасын қолдану мәселелері бойынша кеңес беруде көп жылдық тәжірибе
• 2025 жылдың қаңтарынан бастап — Астана қаласының спорттық медициналық орталығының комплаенс-офицері`
    },
    certificates: {
      ru: `Профессиональная квалификация:
• Член Палаты юридических консультантов г. Алматы
• Профессиональный медиатор
• Специализация в области антикоррупционного законодательства и корпоративной этики`,
      kz: `Кәсіби біліктілік:
• Алматы қаласының заң кеңесшілері палатасының мүшесі
• Кәсіби медиатор
• Сыбайлас жемқорлыққа қарсы заңнама және корпоративтік этика саласындағы мамандандыру`
    }
};
